export const PROJECT_ENV_TARGET = [
  'production',
  'preview',
  'development',
] as const;

export const LOGO = '▲' as const;
export const NAME = 'vercel' as const;
export const TITLE = 'Vercel' as const;
